import clsx from "clsx";
import "./status-indicator.css";

export const Status = ({ className = "", status, ...props }) => (
  <span
    className={clsx(
      "r2-status-indicator",
      status ? `r2-status-indicator--${status}` : "",
      className
    )}
    {...props}
  />
);

export const StatusIndicator = ({ className = "", ...props }) => (
  <span className={clsx("r2-status-indicator__dot", className)} {...props}>
    <span className="r2-status-indicator__ping" />
    <span className="r2-status-indicator__fill" />
  </span>
);
export const StatusLabel = ({ className = "", children, ...props }) => (
  <span className={clsx("r2-status-label", className)} {...props}>
    {children ?? (
      <>
        <span className="r2-status-label__text r2-status-label__text--online">
          Online
        </span>
        <span className="r2-status-label__text r2-status-label__text--offline">
          Offline
        </span>
        <span className="r2-status-label__text r2-status-label__text--maintenance">
          Maintenance
        </span>
        <span className="r2-status-label__text r2-status-label__text--degraded">
          Degraded
        </span>
      </>
    )}
  </span>
);
